// KPI rozet — hero strip altında veya bağımsız kullanılabilir
import React from 'react';

const COLORS = {
  primary: { fg: 'var(--accent-primary)', bg: 'var(--accent-glow)' },
  success: { fg: 'var(--success)',         bg: 'rgba(22,163,74,0.10)' },
  warning: { fg: 'var(--warning)',         bg: 'rgba(245,158,11,0.10)' },
  danger:  { fg: 'var(--danger)',          bg: 'rgba(220,38,38,0.10)' },
  info:    { fg: 'var(--info)',            bg: 'rgba(59,130,246,0.10)' },
  neutral: { fg: 'var(--text-secondary)',  bg: 'var(--bg-secondary)' },
};

export default function CardKpiBadge({ label, value, color = 'primary', sublabel, onClick, compact = false }) {
  const c = COLORS[color] || COLORS.primary;
  const Comp = onClick ? 'button' : 'div';
  return (
    <Comp
      onClick={onClick}
      style={{
        all: 'unset',
        background: c.bg,
        borderRadius: 'var(--r-lg)',
        padding: compact ? '6px 10px' : '8px 12px',
        minWidth: compact ? 80 : 100,
        cursor: onClick ? 'pointer' : 'default',
        boxSizing: 'border-box',
        display: 'inline-block',
        transition: 'transform 0.1s, box-shadow 0.1s',
      }}
      onMouseEnter={onClick ? (e) => { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = 'var(--shadow-sm)'; } : undefined}
      onMouseLeave={onClick ? (e) => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = 'none'; } : undefined}
    >
      <div style={{
        fontSize: compact ? '1.05rem' : '1.25rem',
        fontWeight: 800,
        fontFamily: 'JetBrains Mono, monospace',
        color: c.fg,
        lineHeight: 1.1,
      }}>{value ?? '—'}</div>
      <div style={{
        fontSize: compact ? '0.66rem' : '0.7rem',
        color: 'var(--text-secondary)',
        marginTop: 2,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}>{label}</div>
      {sublabel && (
        <div style={{ fontSize: '0.62rem', color: 'var(--text-tertiary)', marginTop: 1 }}>
          {sublabel}
        </div>
      )}
    </Comp>
  );
}
